export default "/react/navigatorIcon-e3af256b.svg";